//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
export default {
  name: "supplier-visit-list",
  components: {
    divSpan
  },
  data() {
    return {
      uploadUrl:process.env.API_ROOT,
      refresh:true,
      wrapperHeight: 0,
      allLoaded: false,
      config: {
        title: 'ERP信息维护',
        url: 'api/dynamic-form-value/sap_info_modify/page',
        property: "dynamicFormValue.bizId",
        fixRules: [],
        specialCondition: {
          dynamicFormCode: "sap_info_modify"
        },
        inputCondition: {
          placeholder: '供应商名称',
          searchCondition: 'key',
          rules: [{
            field: "field_supplier_id_show",
            option: "LIKE_ANYWHERE"
          }]
        },
        selectConfig:[
          {
            text: '账户组',
            type: 'selector',
            list: [{
              name: "全部",
              code: null
            },{
              name: "新建",
              code: '0'
            },{
              name: "审批中",
              code: '1'
            }],
            rules:[{field:"field_sup_accgrp",option:"IN"}]
          },
          {
            text: '审批状态',
            type: 'selector',
            list: [{
              name: "全部",
              code: null
            },{
              name: "审批中",
              code: 'UnCompleted'
            },{
              name: "已结束",
              code: 'Completed'
            }],
            rules:[{field:"dynaFlowStatus",option:"IN"}]
          }
        ],
      },
      searchData: {},
      contentList: [],
      "cardConfig": {
          "topTitle": {
            "valueField": "field_supplier_id_show",
            "name": "供应商-"
          },
          "status":{
            "valueField":"field_number"
          },
          "content": [
            {
              "icon": "icon-supply",
              "name": "创建人-",
              "valueField": "dynamicFormValue.createdBy"
            },
            {
              "icon": "icon-all",
              "name": "创建日期-",
              "valueField": "dynamicFormValue.createdDate",
              "type":"date"
            }
          ]
        }
    }
  },
  methods: {
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.contentList = this.contentList.concat(e);
        }else{
          this.contentList = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
      this.getOption();
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    conversionName(data, name) {
      let retanData = '';
      if (name) {
        let colName = name.split('.');
        if (data.hasOwnProperty(colName[0])) {
          if (colName.length > 1) {
            for (let i = 0; i < colName.length; i++) {
              if (i == 0) {
                retanData = data[colName[0]];
              } else {
                if (retanData != null) {
                  retanData = retanData[colName[i]];
                } else {
                  return retanData = '';
                }
              }
            }
            return retanData == null ? '' : retanData;
          } else {
            return data[colName[0]] == null ? '' : data[colName[0]];
          }
        } else {
          return retanData == null ? '' : retanData;
        }
      } else {
        return retanData == null ? '' : retanData;
      }
    },
    openFlow(e) {
      let baseUrl;
      if(this.$store.state.systemConfig){
        baseUrl = this.$store.state.systemConfig.systemUrl + '#/';
      }else{
        return;
      }
      this.$store.dispatch('commitChangeIframeUrl',`${baseUrl}jy-sso?token=${this.token}&requestId=${e.dynamicFormValue.bizId}&isMobile=1`);
      this.$router.push('dynamic-flow');
    },
    getOption(){
      this.$get('api/dict-tables/search-with-list?_allow_anonymous=true', { dictCode: 'supAccgrp'}).then((data) => {
        console.log(data)
        data.dictItems.forEach(item => {
          item.name = item.value
        })
        this.config.selectConfig[0].list = data.dictItems;
      })
    }
  },
  mounted() {
    let tokens = localStorage.getItem('_token');
    if(tokens){
      this.token = tokens.substr(7);
    }
    setTimeout(() => {
      this.init();
      this.$refs.header.getlist();
    },600);
  }
}



// WEBPACK FOOTER //
// ./src/page/dynamic-form-list/erp-info-modify/erp-info-modify-list.vue